/*! License details at fancyapps.com/license */
var e = function e(_e) {
    if (!(_e && _e instanceof Element && _e.offsetParent)) return !1;
    var n = _e.scrollHeight > _e.clientHeight,
      t = window.getComputedStyle(_e).overflowY,
      o = -1 !== t.indexOf("hidden"),
      i = -1 !== t.indexOf("visible");
    return n && !o && !i;
  },
  _n = function n(t) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;
    return !t || t === document.body || o && t === o ? null : e(t) ? t : _n(t.parentElement, o);
  };
export { _n as getScrollableParent, e as isScrollable };